import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import Card from 'bundles/apex/card';
import EmptyState from './empty_state';
import Row from './row';

export function HistoryCard({ history, stagesConfig }) {
  return (
    <Card
      className="deal-history-card d-flex flex-column"
      label="History"
      overflowAuto
      verticalBody
    >
      {history.length > 0 ? (
        history.map((event, i) => {
          return <Row event={event} key={i} stagesConfig={stagesConfig} />;
        })) :
        <EmptyState />
      }
    </Card>
  );
}

HistoryCard.propTypes = {
  history: PropTypes.array,
  stagesConfig: PropTypes.array,
};

const mapStateToProps = (state) => {
  return {
    history: state.deal.stageHistory,
    stagesConfig: state.stagesConfig,
  };
};

export default connect(mapStateToProps)(HistoryCard);
